import { useEffect, useRef, useState } from "react";
import React from "react";
import {
  ButtonContainer,
  DialogButton,
  DialogContainer,
  DialogSubtitle,
  DialogTitle,
  DialogAntiActionButton,
} from "./styles";
import { useTranslation } from "react-i18next";

const ReportReadyModal = (props) => {
  const [display, setDisplay] = useState(props.display);
  const { t } = useTranslation();
  useEffect(() => {
    setDisplay(props.display);
  }, [props.display]);

  useEffect(() => {
    if (display) {
      handleOpenModal();
    } else {
      handleCloseModal();
    }
  }, [display]);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const handleOpenModal = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  };
  const handleCloseModal = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
      setDisplay(false);
    }
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  return (
    <DialogContainer display={display} ref={dialogRef}>
      <DialogTitle>
        {t("user.survey.corePro.waiting.ReportReadyModalTitle")}
      </DialogTitle>
      <DialogSubtitle>
        {t("user.survey.corePro.waiting.ReportReadyModalSubtitle")}
      </DialogSubtitle>
      <ButtonContainer>
        <DialogButton onClick={props.onGoToReport}>
          {t("user.survey.corePro.waiting.ReportReadyModalButton1")}
        </DialogButton>
        <DialogAntiActionButton onClick={handleCloseModal}>
          {t("user.survey.corePro.waiting.ReportReadyModalButton2")}
        </DialogAntiActionButton>
      </ButtonContainer>
    </DialogContainer>
  );
};

export default ReportReadyModal;
